<script setup lang="ts">
import { computed, ref } from 'vue'

import { getParticipantTeamSide } from '@collector/shared-ui-domain'
import {
  Participant,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'
import { injectEventIncidentsQueue } from '@desktop/views/Relation/provide-inject'
import PitchIncidentButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchIncidentButton/PitchIncidentButton.vue'

import { useServeIncident } from './useServeIncident'

type Props = {
  participant: Participant
}

const props = defineProps<Props>()

// inject
const eventIncidentsQueue = injectEventIncidentsQueue()

// composables
const { forceDisabled, disabled } = useServeIncident()

// state
const uuid = ref<string | void>()

// computed
const teamSide = computed(() => getParticipantTeamSide(props.participant))

// methods
function handleClick(addIncident: () => void): void {
  uuid.value = addIncident()

  // disable button after click to prevent duplicated Serve from rapid clicks
  forceDisabled.value = true
}

// init
eventIncidentsQueue.subscribeOnChange(({ removedUuid }) => {
  if (removedUuid && uuid.value === removedUuid) {
    forceDisabled.value = false // re-enable button when Serve incident is removed from queue
  }
})
</script>

<template>
  <PitchIncidentButton
    class="row-span-2 w-11 py-11"
    :participant
    :incidentId="VolleyballIncidentId.Serve"
    :variant="teamSide"
    :disabled
    buttonHeightClass="h-full"
    @click="handleClick"
  >
    <span class="-rotate-90">SERVE</span>
  </PitchIncidentButton>
</template>
